// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import investigationFindingEntity from './entities/investigation-finding.json';
import investigationFindingMenu from '../pages/investigation-finding/menu.json';
import investigationFindingFullForm from '../pages/investigation-finding/forms/full.json';
import investigationFindingContextForm from '../pages/investigation-finding/forms/context.json';
import investigationFindingMiniForm from '../pages/investigation-finding/forms/mini.json';
import investigationFindingLookupForm from '../pages/investigation-finding/forms/lookup.json';
import investigationFindingTableView from '../pages/investigation-finding/views/table.json';
import investigationFindingCardsView from '../pages/investigation-finding/views/cards.json';
import investigationFindingDashboardView from '../pages/investigation-finding/views/dashboard.json';

/** Тип запису «Висновок» зі сторінками пакета: меню, форми та подання з pages/investigation-finding/. */
export const investigationFindingDefinition: IRecordTypeDefinition = {
  ...investigationFindingEntity,
  views: assembleViewSet({
      table: investigationFindingTableView,
      cards: investigationFindingCardsView,
      dashboard: investigationFindingDashboardView,
  }),
  form: investigationFindingFullForm,
  forms: { full: investigationFindingFullForm, context: investigationFindingContextForm, mini: investigationFindingMiniForm, lookup: investigationFindingLookupForm },
  menu: investigationFindingMenu,
} as IRecordTypeDefinition;
